import { render } from "./Restaurant.vue?vue&type=template&id=69c7619c&scoped=true"
import script from "./Restaurant.vue?vue&type=script&lang=js"
export * from "./Restaurant.vue?vue&type=script&lang=js"

import "./Restaurant.vue?vue&type=style&index=0&id=69c7619c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-69c7619c"

export default script